import React from 'react';
import './Advertise.css';
import imagevis1 from "../../assets/imagevis1.png";
import imagevis2 from "../../assets/imagevis2.png";
import imagevis3 from "../../assets/imagevis3.png";
import imagevis4 from "../../assets/imagevis4.png";

const Advertise: React.FC = () => {

  return (
    <div className="advertise-wrapper">
      <div className="sdae-options">
        <div className="sdae-option">
          <img className='sdae-image' src={imagevis1} />
          <div className="sdae-content">
            <h4>Rotated Banner</h4>
            <p>Note: Every project receives a minimum of 2 banner spots with a maximum of 4 depending on how many banners are booked</p>
            <p>1D - €100</p>
            <p>3D - €270 (10% off)</p>
            <p>7D - €560 (20% off)</p>
            <p>More days - Custom Price</p>
          </div>
          <a href="https://t.me/m/tchAImwHNTc0" target='_blank' className="buy-ad-button">
            Request now
          </a>
        </div>
        <div className="sdae-option">
          <img className='sdae-image' src={imagevis2} />
          <div className="sdae-content">
            <h4>Pinned Top Position</h4>
            <p>Note: Your project pinned to the most viewed sections on our dashboard with over 5,000 daily visitors.</p>
            <p>1D - €100</p>
            <p>3D - €270 (10% off)</p>
            <p>7D - €560 (20% off)</p>
            <p>More days - Custom Price</p>
          </div>
          <a href="https://t.me/m/Bl5b0c0KNGQ0" target='_blank' className="buy-ad-button">
            Request now
          </a>
        </div>
        <div className="sdae-option">
          <img className='sdae-image' src={imagevis3} />
          <div className="sdae-content">
            <h4>Verified Trending Pinned</h4>
            <p>Note: Each project receives 2 pinned spots in the trending bar for the best exposure.</p>
            <p>1D - €30</p>
            <p>3D - €81 (10% off) </p>
            <p>7D - €168 (20% off)</p>
            <p>More days - Custom Price</p>
          </div>
          <a href="https://t.me/m/cHxhUX-PMDk0" target='_blank' className="buy-ad-button">
            Request now
          </a>
        </div>
        <div className="sdae-option">
          <img className='sdae-image' src={imagevis4} />
          <div className="sdae-content">
            <h4>All Projects Pinned</h4>
            <p>Note: Your project card pinned at the first places of the biggest section on our dashboard.</p>
            <p>1D - €60</p>
            <p>3D - €162 (10% off) </p>
            <p>7D - €336 (20% off)</p>
            <p>More days - Custom Price</p>
          </div>
          <a href="https://t.me/m/I7h2i2Y_NDlk" target='_blank' className="buy-ad-button">
            Request now
          </a>
        </div>
      </div>
    </div>
  );
};

export default Advertise;
